import React, { useEffect, useState } from 'react';
import { Col, Container, Form, FormLabel, Row } from 'react-bootstrap';
import { bg } from '../../../constants/component.constants';
import { agoraChatGroupName, changeBodyClassName } from '../../../utils/utils';
import RoundButton from '../../common/RoundButton';
import DeleteAccount from '../dashboard/DeleteAccount';
import SettingsTitle from '../dashboard/SettingsTitle';
import { useAuth } from '../../auth/Auth';
import defaultBannerImg from '../../../assets/images/Top_banner.png';
import EventEmitter from '../../../utils/events';
import ChangePasswordModal from '../dashboard/ChangePasswordModal';
import PartnerHeader from '../school/PartnerHeader';
import SchoolManagement from '../school/SchoolManagement';
import PersonalizeProfileModal from './PersonalizeProfileModal';
import { partnerViewModel } from '../school/partner.view.model';
import { agoraViewModel } from '../../common/agora.view.model';
import '../dashboard/css/guardian.settings.overview.scss';

const PartnerRoom = () => {
  const { partner, setUser } = useAuth();
  const [customizePopup, setCustomizePopup] = useState(partner && !partner.description ? true : false);
  const defaultBannerUrl = partner && partner?.banner_url ? partner?.banner_url : defaultBannerImg;
  const [bgImg, setBgImg] = useState(defaultBannerUrl);
  const [showPasswordModal, setShowPassWordModal] = useState(false);

  let myRoomImageStyle = {
    backgroundImage: `url(${bgImg})`
  }

  useEffect(() => {
    changeBodyClassName([bg.WHITE]);

    return () => {
      EventEmitter.unsubscribe('partner_banner_pic')
    }
  }, []);

  const createChatGroup = async () => {
    let response = await agoraViewModel.getAppToken()
    let token = response?.data.app_token
    const data = {
      groupname: agoraChatGroupName(partner?.username),
      desc: partner?.username,
      public: true,
      owner: String(partner?.id),
    };

    try {
      await agoraViewModel.createGroup(token, data).then((res) => {
        if (res?.data?.groupid) {
          let params = {
            agora_group_id: res?.data?.groupid
          }
          partnerViewModel
            .addExpertAgoraGroupId(partner?.id, params)
            .then((resp) => {
              setUser(resp);
            });
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const registerUser = async () => {
    let data = {
      username: partner?.id,
      nickname: partner?.id,
      password: 'test@123',
    }
    let response = await agoraViewModel.getAppToken()
    data.appToken = response?.data.app_token
    await agoraViewModel.registerUser(data).then((res) => {
      // getUserToken(res.entities[0].uuid)
      // localStorage.setItem('uuid', res.entities[0].uuid)
      createChatGroup()
    })
      .catch((err) => {
        console.log(err)
      })
  }

  const getUser = async () => {
    let data = {
      username: partner?.id
    }
    let response = await agoraViewModel.getAppToken()
    data.appToken = response?.data.app_token
    await agoraViewModel.getUser(data).then((res) => {
      createChatGroup()
      // localStorage.setItem('uuid', res.entities[0].uuid)
      // getUserToken(res.entities[0].uuid)
      // addUserToGroup()
    }).catch((err) => {
      if (err.statusCode === 404 || err.statusCode === 401) {
        registerUser()
      }
    })
  }

  useEffect(() => {
    if (partner && partner?.user_type === "camp master" && !partner?.profile?.agora_group_id) {
      getUser();
    }
  }, [partner])

  const handleCloseShowPasswordModal = () => {
    setShowPassWordModal(false);
  };

  const getUserBannerPic = (image) => {
    setBgImg(image.preview);
  };

  EventEmitter.subscribe('partner_banner_pic', getUserBannerPic)

  return (
    <div className="guardian-setting-wrapper partner-setting-wrapper partner-wrapper-main">
      <PartnerHeader />
      <Container className={bgImg ? "setting-container no-repeat overlay-container" : "setting-container overlay-container"} style={myRoomImageStyle} fluid="md">
        <Container fluid="md">
          <SchoolManagement
            setCustomizePopup={setCustomizePopup}
          />
        </Container>
      </Container>
      <Container fluid="md">
        <Row className="mt-3">
          <Col className="col-md-8 col-lg-6">
            <SettingsTitle title="Account details" />
            <Form >
              <div className="align-self-center guardian-account-property">
                <FormLabel>Account email: {partner.email}</FormLabel>
              </div>
              <div className="mb-3">
                <RoundButton
                  type="button"
                  label="Change password"
                  onClick={() => setShowPassWordModal(true)}
                  className="mt-3 change-password-button gred-btn"
                />
              </div>
              <div className="guardian-account-sublabel">
                Sign in again after changing your password
              </div>
            </Form>
          </Col>
        </Row>
        <DeleteAccount />
      </Container>
      <ChangePasswordModal
        showPasswordModal={showPasswordModal}
        handleClose={handleCloseShowPasswordModal}
      />
      <PersonalizeProfileModal customizePopup={customizePopup} setCustomizePopup={setCustomizePopup} isEdit={!partner.description ? false : true} />
    </div>
  )
}

export default PartnerRoom;